import styled from 'styled-components';

const InputLabel = styled.p`
    font-size: clamp(0.8rem, 0.7308rem + 0.3077vw, 1rem);
`;

export default InputLabel;